var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStreakOverlay = function SvgStreakOverlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56.534 55.422"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "streak-overlay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    x: 1,
    y: 1,
    fill: "#fff",
    fillOpacity: 0.7,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#streak-overlay_svg__a)",
    style: {
      fill: "none"
    },
    transform: "translate(30.755 30.197)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2bd675",
    stroke: "#fff",
    d: "m19.26 2.75.108.084.13-.043c.536-.179 1.023-.445 1.464-.715q.264-.161.5-.313c.248-.16.481-.307.712-.436.374-.207.69-.33.978-.34.271-.008.546.086.842.383.92.918.852 2.097.556 3.213-.104.389-.23.75-.346 1.085l-.146.432a4 4 0 0 0-.161.61c-.028.173-.036.373.052.541a11.9 11.9 0 0 1 1.33 5.494c0 6.617-5.363 11.98-11.98 11.98-6.616 0-11.98-5.363-11.98-11.98 0-1.844.416-3.59 1.16-5.15.088-.186.075-.392.032-.576a3.2 3.2 0 0 0-.22-.6c-.074-.159-.16-.33-.248-.507l-.08-.163a12 12 0 0 1-.34-.733c-.211-.506-.362-1.024-.347-1.524.013-.487.182-.971.635-1.43.638-.475 1.151-.614 1.57-.595.426.019.795.203 1.14.445.174.122.335.254.495.385l.005.004c.154.127.312.256.466.359s.325.193.51.226a.78.78 0 0 0 .577-.125c1.963-1.306 4.268-2 6.625-1.996 1.396 0 2.377.11 3.258.406.88.297 1.68.788 2.703 1.58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.23 6.383a.5.5 0 0 0-.874-.39L6.619 13.83a.5.5 0 0 0 .38.826h6.023a.5.5 0 0 1 .496.564l-.567 4.398a.5.5 0 0 0 .875.39l6.737-7.836a.5.5 0 0 0-.38-.825H14.16a.5.5 0 0 1-.496-.564z"
  }))));
};
export default SvgStreakOverlay;